import { Archive, CircleCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ProductProductReadModel } from '@r/api/generated/client.schemas.ts';
import { Badge } from '@ui/badge.tsx';
import { cn } from '@r/utils/utils.ts';

interface ProductPublicationStatusBadgeProps {
  product: ProductProductReadModel;
  className?: string;
}

/** Badge de statut de publication (en ligne / archivé) pour le catalogue admin. */
export function ProductPublicationStatusBadge({
  product,
  className
}: ProductPublicationStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      variant="outline"
      className={cn(
        'gap-1.5 border-muted-foreground/20 font-normal',
        product.isArchived ? 'bg-muted/50 text-muted-foreground' : 'bg-emerald-50 text-emerald-700',
        className
      )}
    >
      {product.isArchived ? (
        <Archive className="size-3.5 shrink-0" aria-hidden />
      ) : (
        <CircleCheck className="size-3.5 shrink-0" aria-hidden />
      )}
      {product.isArchived
        ? t('admin.shops.products.status.archived')
        : t('admin.shops.products.status.online')}
    </Badge>
  );
}
